<script>
    import NavbarMenu from './navbar/navbar_menu.svelte';
    import Navbar from '../navbar/navbar.svelte';
    import Footer from './landing_page/footer.svelte';
    import {HeroForm} from '../store.js';
    import ThankYou from '../thankyou_popup/thanku.svelte';
    import {showThankUPopUp} from './store.js';
    import {getContext} from 'svelte';
    const {url} = getContext('APP');
    const urlParam = Object.fromEntries(new URLSearchParams($url.search));
    const {title} = rpcjs.props;
    title.set('Apply | Program');
    const founder = [
        {
            title: 'Fundamentals of <br> Entrepreneurship',
            week: 'Virtual - 2 weeks',
            loc: '/apply?name=FundamentalsOfEntrepreneurship&FormNo=firstform',
        },
        {
            title: 'Hero <br> Training',
            week: 'Silicon Valley - 5 Weeks',
            loc: '/apply?name=HeroTraining&FormNo=firstform',
        },
        {
            title: 'House of <br> Ceek',
            week: 'Virtual - 2 weeks',
            loc: '/apply?name=HouseOfCeek&FormNo=firstform',
        },
        {
            title: 'Kanoo <br> Innovation Hub',
            week: 'Silicon Valley - 5 Weeks',
            loc: '/apply?name=KanooInnovationHub&FormNo=firstform',
        },
    ];
    const Executives = [
        {
            title: 'Corporate Innovation<br>Program',
            week: 'Hybrid - 5 days',
            loc: '/apply?name=CorporateInnovation&FormNo=firstform',
        },
        {
            title: 'Blockchain <br> Accelerators ',
            week: 'Hybrid - 10 weeks',
            loc: '/apply?name=Blockchain&FormNo=firstform',
        },
        {
            title: 'Corporate <br> Accelerators',
            week: 'Hybrid - 8-10 weeks ',
            loc: '/apply?name=CorporateAccelerator&FormNo=firstform',
        },
    ];
    const Investors = [
        {
            title: 'VCx',
            loc: '/apply?name=VCX',
        },
        {
            title: 'Invest <br> with Us',
            loc: '/apply?name=investor',
        },
    ];
    const Government = [
        {
            title: 'Government <br> Program',
            loc: '/apply?name=Government',
        },
    ];
    if (HeroForm.get() == undefined) {
        HeroForm.update((n)=> n={session: '', name: '', email: '', country: '', countryCode: '', city: '', phoneNumber: '',
            dateOfBirth: '', gender: '', technicalSkill: '', englishAbility: '', industry: '', industryOther: '',
            business: '', visa: '', aid: '', referalName: '', hearAbout: '', hearAboutOthers: '',
            Startup: '', aboutYourSelf: ''});
    };
    // <!-- Google Tag Manager -->
(function(w, d, s, l, i) {
        w[l]=w[l]||[]; w[l].push({'gtm.start':
        new Date().getTime(), 'event': 'gtm.js'}); const f=d.getElementsByTagName(s)[0];
        const j=d.createElement(s); const dl=l!='dataLayer'?'&l='+l:''; j.async=true; j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl; f.parentNode.insertBefore(j, f);
    })(window, document, 'script', 'dataLayer', 'GTM-N8TD4HQ');
    // <!-- End Google Tag Manager -->
    /**
     *
     *
    */
    function displayPopUp() {
        showThankUPopUp.update((n) => n + 1);
    }
    if (urlParam.status === 'formsubmit') {
        displayPopUp();
    }
</script>

<header>
    <div class="desktop">
        <Navbar></Navbar>
    </div>
    <div class="mobile">
        <div style="width:72.6vw;">
            <NavbarMenu
            backgroundColor="white" stroke="#3C74C0" Opacity="0.8"
            />
        </div>
    </div>
</header>
<ThankYou headingText='FORM SUBMITTED' paraText='Your Form has been successful submitted.
    We will get to you after the process is completed'/>
<section  class="header" >
    <div style="text-align:center;padding-top: 7vw;">
        <h1 class="main-head">Apply to DraperU</h1>
        <h6 class="main-head-para">
            go from an idea to a product ready to pitch to investors
        </h6>
    </div>
    <div class="title-align">
        <h1 class="second-heading">Programs</h1>
        <h6 class="second-heading-para">
            Choose your preferred program and an avaliable session.
        </h6>
    </div>
    <div class="content-align">
        <div style="margin-top:4vw;
        margin-left:2vw;">
            <h4 class="pTitle">Founders</h4>
            <div class="display">
                {#each founder as data}
                    <div class="Pbox" style="margin-top:1.323vw" on:click={()=>{
location.href= data.loc;
}}>
                        <div>
                            <h5 class="boxTitle">
                                {@html data.title}
                            </h5>
                            <p class="box-days">{@html data.week}</p>
                        </div>
                    </div>
                {/each}
            </div>
        </div>
        <div style="margin-top:4vw;
        margin-left:2vw;">
            <h4 style="margin-bottom:1.323vw" class="pTitle">Executives</h4>
            <div class="display">
                {#each Executives as data}
                    <div class="Pbox" on:click={()=>{
                        location.href= data.loc;
}}>
                        <div>
                            <h5 class="boxTitle">
                                {@html data.title}
                            </h5>
                            <p class="box-days">{@html data.week}</p>
                        </div>
                    </div>
                {/each}
            </div>
        </div>
        <div style="margin-top:4vw;
        margin-left:2vw;">
            <div class="display" style="justify-content: space-between;">
                <div>
                    <h4 style="margin-bottom:2.712vw" class="pTitle">Investors</h4>
                    <div class="display">
                        {#each Investors as data}
                            <div class="Psuqare" on:click={()=>{
                                location.href= data.loc;
                                }}>
                                <div>
                                    <h5 class="boxTitle">
                                        {@html data.title}
                                    </h5>
                                </div>
                            </div>
                        {/each}
                    </div>
                </div>
                <div style="margin-left:4vw;">
                    <h4 style="margin-bottom:2.712vw" class="pTitle">Government</h4>
                    <div class="display">
                        {#each Government as data}
                            <div class="Psuqare" on:click={()=>{
                                location.href=data.loc;
                                }}>
                                <div>
                                    <h5 class="boxTitle">
                                        {@html data.title}
                                    </h5>
                                </div>
                            </div>
                        {/each}
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<footer>
    <Footer />
</footer>

<style>
    .main-head {
        margin-bottom: 1vw;
        font-size: 3.307vw;
        color: #00204b;
        font-weight: bolder;
        text-transform: uppercase;
        background: linear-gradient(1.05deg, #00204b 50.19%, #00429b 99.35%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
        text-fill-color: transparent;
    }
    .main-head-para {
        color: #00204b;
        font-size: 1.323vw;
    }
    .second-heading {
        margin-bottom: 1vw;
        font-size: 1.984vw;
        color: #00204b;
        text-transform: uppercase;
        font-weight: 800 !important;
    }
    .second-heading-para {
        font-size: 0.926vw;
        color: #00204b;
    }
    .pTitle {
        font-size: 1.653vw;
        font-weight: 600;
    }
    .Pbox {
        padding: 4vw 2vw;
        width: 19.18vw;
        height: 15.212vw;
        border: 0.331vw solid #e5eff7;
        border-radius: 0.661vw;
        margin-right: 1vw;
        position: relative;
        cursor: pointer;
    }
    .Pbox:hover {
        background-color: #e5eff7;
    }
    .Pbox:hover:after {
        content: "";
        position: absolute;
        height: 0.7vw;
        bottom: 1.5vw;
        right: 2vw;
        width: 0.7vw;
        border: 0.2vw solid black;
        border-left: none;
        border-bottom: none;
        transform: rotate(45deg);
        animation: arrow 0.4s 0s 1;
    }
    @keyframes arrow {
        0% {
            right: 4vw;
        }
        100% {
            right: 2vw;
        }
    }
    .Pbox:hover:before {
        content: "";
        position: absolute;
        bottom: 1.8vw;
        width: 3.5vw;
        border-bottom: 0.2vw solid black;
        left: 13vw;
        animation: width 0.3s 0s 1;
    }
    @keyframes width {
        0% {
            width: 0;
        }
        100% {
            width: 3.5vw;
        }
    }
    .Psuqare {
        padding: 4vw 2vw;
        width: 19.18vw;
        height: 11.243vw;
        border: 0.331vw solid #e5eff7;
        border-radius: 0.661vw;
        margin-right: 1vw;
        position: relative;
        cursor: pointer;
    }
    .Psuqare:hover {
        background-color: #e5eff7;
    }
    .Psuqare:hover:after {
        content: "";
        position: absolute;
        height: 0.7vw;
        bottom: 1.5vw;
        right: 2vw;
        width: 0.7vw;
        border: 0.2vw solid black;
        border-left: none;
        border-bottom: none;
        transform: rotate(45deg);
        transition-duration: 1s;
        animation: arrow 0.4s 0s 1;
    }
    @keyframes arrow {
        0% {
            right: 4vw;
        }
        100% {
            right: 2vw;
        }
    }
    .Psuqare:hover:before {
        content: "";
        position: absolute;
        bottom: 1.8vw;
        width: 3.5vw;
        border-bottom: 0.2vw solid black;
        left: 13vw;
        animation: width 0.3s 0s 1;
    }
    @keyframes width {
        0% {
            width: 0;
        }
        100% {
            width: 3.5vw;
        }
    }
    .boxTitle {
        font-size: 1.455vw;
        color: #00204b;
        margin-bottom: 1vw;
    }
    .box-days {
        font-size: 1.19vw;
    }
    .display {
        display: flex;
        flex-wrap: wrap;
    }
    .content-align {
        width: 67vw;
        margin: auto;
    }
    .title-align {
        margin-top: 5vw;
    }
    .desktop {
        display: block;
    }
    .mobile {
        display: none;
    }
    .header {
        padding: 7vw;
    }
    @media screen and (max-width: 1024px) {
        .desktop {
            display: none;
        }
        .mobile {
            display: block;
        }
        .header {
            padding: 30vw 0 !important;
            text-align: center;
            margin-top: 0!important;
        }
        .main-head {
            font-size: 8.333vw;
        }
        .main-head-para {
            font-size: 4.444vw;
            text-transform: uppercase;
            width: 68vw;
            margin: 10vw auto;
        }
        .second-heading {
            margin-bottom: 1vw;
            font-size: 5.556vw;
            color: #00204b;
            text-transform: uppercase;
            font-weight: 800 !important;
            text-align: start;
        }
        .second-heading-para {
            font-size: 3.056vw;
            color: #00204b;
            text-align: start;
        }
        .pTitle {
            font-size: 5vw;
            font-weight: 600;
            margin: 8vw 0;
            text-align: start;
        }
        .Pbox {
            padding: 4vw 4vw;
            width: 65.922vw;
            height: 52.283vw;
            border: 1.134vw solid #e5eff7;
            border-radius: 2vw;
            margin-top: 3vw;
        }
        .Psuqare {
            padding: 4vw 4vw;
            width: 65.922vw;
            height: 38.592vw;
            border: 1.134vw solid #e5eff7;
            border-radius: 2vw;
            margin-top: 3vw;
        }
        .boxTitle {
            font-size: 4.969vw;
            padding-top: 10vw;
            text-align: start;
            font-weight: 600;
        }
        .box-days {
            font-size: 4.064vw;
            text-align: start;
        }
        .display {
            display: block;
        }
        .content-align {
            width: 90vw;
            margin: auto 10vw;
        }
        .title-align {
            width: 60vw;
            margin: 20vw 10vw;
        }
    }
</style>
